import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

const KINDS = [["workbook", "Workbook"], ["homework", "Homework / mock exam"], ["annotations", "Workbook annotations"], ["solutions", "Workbook solutions"], ["file", "Other file"]];

export function AddItemDialog({ unit, course, onClose, onSaved }) {
  const [kind, setKind] = useState("workbook");
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [hwId, setHwId] = useState("");
  const [hws, setHws] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!unit) return;
    setKind("workbook"); setTitle(""); setFile(null); setHwId("");
    const secs = course.sections || [course.section];
    api.get("/homework").then((r) => setHws(r.data.filter((h) => h.program === course.program && secs.includes(h.section))));
  }, [unit, course.program, course.section, (course.sections || []).join(",")]);
  if (!unit) return null;
  const save = async () => {
    if (kind === "homework" ? !hwId : !file) return toast.error(kind === "homework" ? "Choose a homework." : "Attach a file.");
    const fd = new FormData();
    fd.append("kind", kind); fd.append("title", title);
    if (kind === "homework") fd.append("homework_id", hwId); else fd.append("file", file);
    setBusy(true);
    try { await api.post(`/courses/units/${unit.id}/items`, fd); toast.success("Added."); onSaved(); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not add item."); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="mn max-w-md" data-testid="add-item-dialog">
        <DialogHeader><DialogTitle className="text-xl font-extrabold">Add to "{unit.title}"</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Type</Label>
            <Select value={kind} onValueChange={setKind}>
              <SelectTrigger data-testid="item-kind-select" className="mt-1.5 h-11 rounded-xl"><SelectValue /></SelectTrigger>
              <SelectContent>{KINDS.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
            </Select></div>
          <div><Label>Name shown to students</Label>
            <Input data-testid="item-title-input" value={title} onChange={(e) => setTitle(e.target.value)} placeholder={kind === "homework" ? "e.g. 1.1 Homework" : "e.g. 1.1 Workbook"} className="mt-1.5 h-11 rounded-xl" /></div>
          {kind === "homework" ? (
            <div><Label>Homework</Label>
              <Select value={hwId} onValueChange={setHwId}>
                <SelectTrigger data-testid="item-homework-select" className="mt-1.5 h-11 rounded-xl"><SelectValue placeholder={hws.length ? "Choose homework" : "No homework in this subject yet"} /></SelectTrigger>
                <SelectContent>{hws.map((h) => <SelectItem key={h.id} value={h.id}>{h.title}{h.status !== "released" ? " (draft)" : ""}</SelectItem>)}</SelectContent>
              </Select></div>
          ) : (
            <div><Label>File (PDF)</Label>
              <Input type="file" accept=".pdf,application/pdf,.doc,.docx,.ppt,.pptx" data-testid="item-file-input" onChange={(e) => setFile(e.target.files?.[0] || null)} className="mt-1.5 rounded-xl" /></div>
          )}
        </div>
        <DialogFooter><Button onClick={save} disabled={busy} data-testid="item-save-btn" className="rounded-xl ember-gradient font-bold">{busy ? "Uploading…" : "Add"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
